import React from 'react'

function Invitatiion ({ applicationResults }: any) {
  return (
    <div className='pscreen-section pscreen-section--official'>
                <div className='section-header section-header--teamlead'>
                  <h2>Section B: Invitation</h2>
                  <span className='section-badge'>Candidate Schedule</span>
                </div>

                <table className='credentials-table'>
                  <tbody>
                    <tr>
                      <td className='credentials-table__label'>Venue:</td>
                      <td className='credentials-table__field' colSpan={3}>{applicationResults?.workflow?.pScreen.scheduleSchema?.['pscreen-venue']}</td>
                    </tr>
                    <tr>
                      <td className='credentials-table__label'>Time:</td>
                      <td className='credentials-table__field'>{applicationResults?.workflow?.pScreen.scheduleSchema?.['pscreen-time']}</td>
                      <td className='credentials-table__label'>Date:</td>
                      <td className='credentials-table__field'>{applicationResults?.workflow?.pScreen.scheduleSchema?.['pscreen-date']}</td>
                    </tr>
                    <tr>
                      <td className='credentials-table__label'>Table:</td>
                      <td className='credentials-table__field'>{applicationResults?.workflow?.pScreen.scheduleSchema?.batch}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
  )
}

export default Invitatiion
